import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateOrdersByTnos, viewUpdateOrdersByTno } from '../../../actions/utActions';
import TableList from '../TableList';
import { Button, FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, TextField, withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { getCurrentWarehouse, handleCapitalize } from '../../../utilities/common';
import ReactExport from "react-export-excel";
import ExceptionDialog from '../../EditOrderModal/NextTransition/ExceptionDialog';
import { getExceptionByState } from '../../../actions/editOrderActions';
import FullScreenLoading from '../../Common/FullscreenLoading';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

function ParcelUpdate(props) {
    const {t} = useTranslation('updateToolbox');
    const dispatch = useDispatch();
    let warehouse = getCurrentWarehouse()['id'];

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const exceptionId = useRef(null)

    const [state, setState] = useState(199);
    const [tnos, setTnos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [subBatch, setSubBatch] = useState('');
    const [checkedBatch, setCheckedBatch] = useState(false);
    const [updated, setUpdated] = useState(0);
    const [failedUpdatedOrders, setFailedUpdatedOrders] = useState([]);
    const [openExceptionDialog, setOpenExceptionDialog] = useState(false);
    const [exceptionList, setExceptionList] = useState([]);

    const [totalWeight, setTotalWeight] = useState();

    const handleStateChange = (event) => {
        setState(event.target.value);
    };
    const handleTnosChange = (event) => {
        setTnos();
        setTnos(event.target.value);
    };
    const handleSubBatch = (event) => {
        setSubBatch(handleCapitalize(event.target.value));
    };

    useEffect(() => {
        if(!checkedBatch) {
            setSubBatch('');
        }
    }, [checkedBatch])

    useEffect(() => {
        setTnos();
        setFailedUpdatedOrders([]);
        resetData();
        dispatch(getExceptionByState(219))
        .then((res) => {
            setExceptionList(res)
        })
        setTotalWeight();
    }, [])

    function transferTnos(tnos) {
        let newTnos = tnos.split('\n');        
        let newTnosCurr = '';
        newTnos.forEach((element) => {
            if(element) {
                newTnosCurr = newTnosCurr.concat(',' + element.trim());
            }
        });
        return newTnosCurr.substring(1);
    }
    function checkFormat(tnos) {
        var tnoRegex = /^[-+]?(?:[0-9a-zA-Z]+,)*[0-9a-zA-Z]+(?:[0-9a-zA-Z]+)?$/i;
        if(tnoRegex.test(tnos)) {
            return true;
        } else {
           return false;
        }
    }
    function handleSubmit() {
        if(state === 219) {
            setOpenExceptionDialog(true);
            setLoading(false);
            return;
        } else {
            handleTnos();
        }
    }
    async function handleTnos() {
        if(tnos.length > 0) {
            const tnosCurr = transferTnos(tnos);
            if(tnosCurr) {
                if(checkFormat(tnosCurr)) {
                    setLoading(true);
                    dispatch(updateOrdersByTnos(tnosCurr, state, subBatch, warehouse, exceptionId.current))
                    .then(() => {
                        dispatch(showAlertSnackbar({message: t('view_generate_report_later'), type: 'success'}))
                    })
                    .catch((err) => {
                        dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                    })
                    .finally(() => {
                        setLoading(false);
                    })
                } else {
                    dispatch(showAlertSnackbar({message: t('format_warning_message'), type: 'warning'}))
                }
            }
        } else {
            dispatch(showAlertSnackbar({message: t('empty_warning_message'), type: 'warning'}))
        }       
    }
    function viewUpdatedOrders() {
        let params = {
            tnos: transferTnos(tnos),
            state: state,
            sub_batch: subBatch
        }
        setLoading(true);
        dispatch(viewUpdateOrdersByTno(params))
        .then((res) => {
            if(res.history.length > 0) {
                setTotalWeight(res.total_weight);
                let fail = [];
                let finished = true;
                res.map((order) => {
                    if(order.status === 0) {
                        fail.push(order)
                    } else if(order.status === -1) {
                        dispatch(showAlertSnackbar({message: t('still_processing'), type: 'warning'}))
                        finished = false;
                        return;
                    }
                })
                if(finished) {
                    if(fail.length === 0) {
                        dispatch(showAlertSnackbar({message: t('all_updated_successfully'), type: 'success'}))
                    } else {
                        dispatch(showAlertSnackbar({message: t('failed_exist_download'), type: 'warning'}))
                        setFailedUpdatedOrders(fail);
                    }
                }
            }
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('report_error'), type: 'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }
    function resetData(){
        exceptionId.current = null
        setDisabled(false); 
    }

    return (
        <>
            <div 
                style={{
                    display: 'flex'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Select
                        value={state}
                        onChange={handleStateChange}
                        variant="outlined"
                        style={{ width: 340 }}
                    >
                        <MenuItem value={199}>{t('199')}</MenuItem>
                        <MenuItem value={195}>{t('195')}</MenuItem>
                        <MenuItem value={207}>{t('207')}</MenuItem>
                        <MenuItem value={215}>{t('215')}</MenuItem>
                        <MenuItem value={218}>{t('218')}</MenuItem>
                        <MenuItem value={219}>{t('219')}</MenuItem>
                        <MenuItem value={230}>{t('230')}</MenuItem>
                        <MenuItem value={255}>{t('255')}</MenuItem>
                    </Select>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 20, 
                            marginBottom: 5
                        }}
                    >
                        <div 
                            onClick={() => setCheckedBatch(!checkedBatch)}
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Checkbox checked={checkedBatch}></Checkbox>
                            <span>{t('link_batch')}</span>
                        </div>
                        <div>
                            <InputTextField
                                variant='outlined'
                                placeholder={t('input_link_batch')}
                                disabled={!checkedBatch}
                                onChange={handleSubBatch}
                                value={subBatch}
                            />
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 20
                    }}
                >
                    <FixedTextField
                        variant='outlined'
                        placeholder={t('input_parcel_no')}
                        multiline
                        rows={6}
                        onChange={handleTnosChange}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: 10 }}
                        onClick={handleSubmit}
                        disabled={disabled || !tnos}
                    >
                        {t('confirm_lot_update')}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: 10 }}
                        onClick={viewUpdatedOrders}
                        disabled={disabled || !tnos}
                    >
                        {t('fetch_lot_update')}
                    </Button>
                    {
                        (failedUpdatedOrders && failedUpdatedOrders.length > 0) ?
                        <ExcelFile
                            element={
                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: 10 }}
                                    disabled={failedUpdatedOrders.length <= 0}
                                >
                                    {t('download_lot_update')}
                                </Button>
                            }
                        >
                            <ExcelSheet data={failedUpdatedOrders} name="Failed Updated Orders">
                                <ExcelColumn label='tno' value='tno'/>
                            </ExcelSheet>
                        </ExcelFile>
                        :
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginLeft: 10 }}
                            disabled
                        >
                            {t('download_lot_update')}
                        </Button>
                    }
                </div>   
                           
            </div>
            {
                totalWeight &&
                <div style={{textAlign: 'right'}}>{t('total_weight')}{totalWeight}</div>
            } 
            <ExceptionDialog
                exceptions={exceptionList}
                open={openExceptionDialog}
                onClose={()=>{
                    setOpenExceptionDialog(false)
                    resetData()
                }}
                onFinish={(value)=>{
                    exceptionId.current = value
                    handleTnos()
                }}
            />
            <FullScreenLoading open={loading} />
        </>
    );
}

export default ParcelUpdate;